/**
 * Segment of the Customer
 */
export type BillingPartyBasicCustSegment =
  (typeof BillingPartyBasicCustSegment)[keyof typeof BillingPartyBasicCustSegment];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BillingPartyBasicCustSegment = {
  R: 'R',
  SMB: 'SMB',
  CORP: 'CORP',
  GOV: 'GOV',
} as const;
